import keyBy from 'lodash/keyBy';
import { HttpClient } from './http-client';

export const traceDetails = process.env.TRACE_DETAILS?.trim() ? keyBy(process.env.TRACE_DETAILS.split(',').map((f) => f.trim()).filter(Boolean)) : undefined;
export const publicClient = new HttpClient({
	baseUrl: process.env.NODE_ENV === 'production' ? '/inventory/api' : '/api/inventory',
	isPublic: true,
	traceDetails,
});
export const privateClient = new HttpClient({
	baseUrl: (process.env.USE_MOCK === 'true' ? 'http://localhost:' + process.env.MOCK_HOST_PORT : process.env.INVENTORY_ORIGIN as string) + '/inventory/api',
	traceDetails,
});

